// AUTO-GENERATED by scripts/gen-monster-pack-manifest.js — do not edit.
// Regenerate after copying new assets: node scripts/gen-monster-pack-manifest.js

export const FRAME_SIZE = 128;

export const MONSTER_PACKS = {
  "slime": {
    "name": "Slime",
    "theme": "Slimes",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "slime_antenna": {
    "name": "Slime Antenna",
    "theme": "Slimes",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "bodyguard": {
    "name": "Bodyguard",
    "theme": "Knights",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "squire": {
    "name": "Squire",
    "theme": "Knights",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "feline_bobcat": {
    "name": "Feline Bobcat",
    "theme": "Felines",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "feline_mutated_panther": {
    "name": "Feline Mutated Panther",
    "theme": "Felines",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "necromancer_down": {
    "name": "Necromancer Down",
    "theme": "Mages",
    "anims": {
      "idle": {
        "rows": 1,
        "frameSize": 64,
        "frames": 6
      },
      "move": {
        "rows": 1,
        "frameSize": 64,
        "frames": 9
      },
      "attack": {
        "rows": 1,
        "frameSize": 64,
        "frames": 9
      }
    },
    "frames": {
      "idle": 6,
      "move": 9,
      "attack": 9
    },
    "frameSize": 64,
    "rows": 1
  },
  "necromancer_side": {
    "name": "Necromancer Side",
    "theme": "Mages",
    "anims": {
      "idle": {
        "rows": 1,
        "frameSize": 64,
        "frames": 6
      },
      "move": {
        "rows": 1,
        "frameSize": 64,
        "frames": 9
      },
      "attack": {
        "rows": 1,
        "frameSize": 64,
        "frames": 9
      }
    },
    "frames": {
      "idle": 6,
      "move": 9,
      "attack": 9
    },
    "frameSize": 64,
    "rows": 1
  },
  "necromancer_up": {
    "name": "Necromancer Up",
    "theme": "Mages",
    "anims": {
      "idle": {
        "rows": 1,
        "frameSize": 64,
        "frames": 6
      },
      "move": {
        "rows": 1,
        "frameSize": 64,
        "frames": 9
      },
      "attack": {
        "rows": 1,
        "frameSize": 64,
        "frames": 9
      }
    },
    "frames": {
      "idle": 6,
      "move": 9,
      "attack": 9
    },
    "frameSize": 64,
    "rows": 1
  },
  "necromancer": {
    "name": "Necromancer",
    "theme": "Mages",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "wizard": {
    "name": "Wizard",
    "theme": "Mages",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "golem_blue": {
    "name": "Golem Blue",
    "theme": "Golems",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "golem_green": {
    "name": "Golem Green",
    "theme": "Golems",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "golem_red": {
    "name": "Golem Red",
    "theme": "Golems",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "golem_yellow": {
    "name": "Golem Yellow",
    "theme": "Golems",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "harpy": {
    "name": "Harpy",
    "theme": "Harpy",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "harpy_undead": {
    "name": "Harpy Undead",
    "theme": "Harpy",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "snake_alien": {
    "name": "Snake Alien",
    "theme": "Snakes",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "snake_viper": {
    "name": "Snake Viper",
    "theme": "Snakes",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 5,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "peasant_female_a": {
    "name": "Peasant Female A",
    "theme": "Peasants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "peasant_female_b": {
    "name": "Peasant Female B",
    "theme": "Peasants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "peasant_female_c": {
    "name": "Peasant Female C",
    "theme": "Peasants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "peasant_male_a": {
    "name": "Peasant Male A",
    "theme": "Peasants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "peasant_male_b": {
    "name": "Peasant Male B",
    "theme": "Peasants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "peasant_male_c": {
    "name": "Peasant Male C",
    "theme": "Peasants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "archer": {
    "name": "Archer",
    "theme": "Knights",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "guardsman": {
    "name": "Guardsman",
    "theme": "Knights",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "mushroom": {
    "name": "Mushroom",
    "theme": "Mushrooms",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "mushroom_party": {
    "name": "Mushroom Party",
    "theme": "Mushrooms",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "spider": {
    "name": "Spider",
    "theme": "Spiders",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "spider_albino": {
    "name": "Spider Albino",
    "theme": "Spiders",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "spider_large": {
    "name": "Spider Large",
    "theme": "Spiders",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "ant": {
    "name": "Ant",
    "theme": "Ants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "ant_mini": {
    "name": "Ant Mini",
    "theme": "Ants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "boar": {
    "name": "Boar",
    "theme": "Bovine",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "pig": {
    "name": "Pig",
    "theme": "Bovine",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "piggy": {
    "name": "Piggy",
    "theme": "Bovine",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "mushroom_treant": {
    "name": "Mushroom Treant",
    "theme": "Mushrooms",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "mushroom_infectous": {
    "name": "Mushroom Infectous",
    "theme": "Mushrooms",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "armored": {
    "name": "Armored",
    "theme": "Canines",
    "anims": {
      "idle": {
        "rows": 3,
        "frameSize": 128,
        "frames": 3
      },
      "move": {
        "rows": 3,
        "frameSize": 128,
        "frames": 5
      },
      "attack": {
        "rows": 3,
        "frameSize": 128,
        "frames": 5
      }
    },
    "frames": {
      "idle": 3,
      "move": 5,
      "attack": 5
    },
    "frameSize": 128,
    "rows": 3
  },
  "beagle": {
    "name": "Beagle",
    "theme": "Canines",
    "anims": {
      "idle": {
        "rows": 3,
        "frameSize": 128,
        "frames": 3
      },
      "move": {
        "rows": 3,
        "frameSize": 128,
        "frames": 5
      },
      "attack": {
        "rows": 3,
        "frameSize": 128,
        "frames": 5
      }
    },
    "frames": {
      "idle": 3,
      "move": 5,
      "attack": 5
    },
    "frameSize": 128,
    "rows": 3
  },
  "labrador": {
    "name": "Labrador",
    "theme": "Canines",
    "anims": {
      "idle": {
        "rows": 3,
        "frameSize": 128,
        "frames": 3
      },
      "move": {
        "rows": 3,
        "frameSize": 128,
        "frames": 5
      },
      "attack": {
        "rows": 3,
        "frameSize": 128,
        "frames": 5
      }
    },
    "frames": {
      "idle": 3,
      "move": 5,
      "attack": 5
    },
    "frameSize": 128,
    "rows": 3
  },
  "troll_battle": {
    "name": "Troll Battle",
    "theme": "Trolls",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "troll": {
    "name": "Troll",
    "theme": "Trolls",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "bear": {
    "name": "Bear",
    "theme": "Bears",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "bear_cub": {
    "name": "Bear Cub",
    "theme": "Bears",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "bear_mutant": {
    "name": "Bear Mutant",
    "theme": "Bears",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "mmg_1": {
    "name": "MMG-1",
    "theme": "Machines",
    "anims": {
      "idle": {
        "rows": 3,
        "frameSize": 128,
        "frames": 3
      },
      "attack": {
        "rows": 3,
        "frameSize": 128,
        "frames": 5
      }
    },
    "frames": {
      "idle": 3,
      "attack": 5
    },
    "frameSize": 128,
    "rows": 3
  },
  "mr_63": {
    "name": "MR-63",
    "theme": "Machines",
    "anims": {
      "idle": {
        "rows": 3,
        "frameSize": 128,
        "frames": 3
      },
      "attack": {
        "rows": 3,
        "frameSize": 128,
        "frames": 5
      }
    },
    "frames": {
      "idle": 3,
      "attack": 5
    },
    "frameSize": 128,
    "rows": 3
  },
  "pirate_boatswain": {
    "name": "Pirate Boatswain",
    "theme": "Pirates",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "pirate_lord": {
    "name": "Pirate Lord",
    "theme": "Pirates",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "knight_dark": {
    "name": "Knight Dark",
    "theme": "Knights",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "royalguard": {
    "name": "RoyalGuard",
    "theme": "Knights",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "dionaea": {
    "name": "Dionaea",
    "theme": "Plants",
    "anims": {
      "idle": {
        "rows": 1,
        "frameSize": 64,
        "frames": 11
      },
      "attack": {
        "rows": 1,
        "frameSize": 64,
        "frames": 21
      }
    },
    "frames": {
      "idle": 11,
      "attack": 21
    },
    "frameSize": 64,
    "rows": 1
  },
  "venus": {
    "name": "Venus",
    "theme": "Plants",
    "anims": {
      "idle": {
        "rows": 1,
        "frameSize": 64,
        "frames": 6
      },
      "attack": {
        "rows": 1,
        "frameSize": 64,
        "frames": 18
      }
    },
    "frames": {
      "idle": 6,
      "attack": 18
    },
    "frameSize": 64,
    "rows": 1
  },
  "goblin_dual": {
    "name": "Goblin Dual",
    "theme": "Goblins",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "goblin_spear": {
    "name": "Goblin Spear",
    "theme": "Goblins",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "pirate_carpenter": {
    "name": "Pirate Carpenter",
    "theme": "Pirates",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "pirate_mate": {
    "name": "Pirate Mate",
    "theme": "Pirates",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "frozen_icer": {
    "name": "Frozen Icer",
    "theme": "Frozen",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "frozen_scorpion": {
    "name": "Frozen Scorpion",
    "theme": "Frozen",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "frozen_widow": {
    "name": "Frozen Widow",
    "theme": "Frozen",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "pirate_seaman_blue": {
    "name": "Pirate Seaman Blue",
    "theme": "Pirates",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "pirate_seaman_red": {
    "name": "Pirate Seaman Red",
    "theme": "Pirates",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "monk": {
    "name": "Monk",
    "theme": "Mages",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "priest": {
    "name": "Priest",
    "theme": "Mages",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "marksman": {
    "name": "Marksman",
    "theme": "Knights",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "spearman": {
    "name": "Spearman",
    "theme": "Knights",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "highborn": {
    "name": "Highborn",
    "theme": "Knights",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "templar": {
    "name": "Templar",
    "theme": "Knights",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "elemental_earth_1": {
    "name": "Elemental Earth 1",
    "theme": "Elementals",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "elemental_earth_2": {
    "name": "Elemental Earth 2",
    "theme": "Elementals",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "elemental_earth_3": {
    "name": "Elemental Earth 3",
    "theme": "Elementals",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "elemental_fire_1": {
    "name": "Elemental Fire 1",
    "theme": "Elementals",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "elemental_fire_2": {
    "name": "Elemental Fire 2",
    "theme": "Elementals",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "elemental_fire_3": {
    "name": "Elemental Fire 3",
    "theme": "Elementals",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "elemental_water_1": {
    "name": "Elemental Water 1",
    "theme": "Elementals",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "elemental_water_2": {
    "name": "Elemental Water 2",
    "theme": "Elementals",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "elemental_water_3": {
    "name": "Elemental Water 3",
    "theme": "Elementals",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "elemental_air_1": {
    "name": "Elemental Air 1",
    "theme": "Elementals",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "elemental_air_2": {
    "name": "Elemental Air 2",
    "theme": "Elementals",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "elemental_air_3": {
    "name": "Elemental Air 3",
    "theme": "Elementals",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "general": {
    "name": "General",
    "theme": "Knights",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "knight": {
    "name": "Knight",
    "theme": "Knights",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "skeleton": {
    "name": "Skeleton",
    "theme": "Skeletons",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "witch_doctor": {
    "name": "Witch Doctor",
    "theme": "Skeletons",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "skeleton_thug": {
    "name": "Skeleton Thug",
    "theme": "Skeletons",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "skeleton_warlord": {
    "name": "Skeleton  Warlord",
    "theme": "Skeletons",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "skeleton_caster": {
    "name": "Skeleton Caster",
    "theme": "Skeletons",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "skeleton_mage": {
    "name": "Skeleton Mage",
    "theme": "Skeletons",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "skeleton_archer": {
    "name": "Skeleton Archer",
    "theme": "Skeletons",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "skeleton_marksman": {
    "name": "Skeleton Marksman",
    "theme": "Skeletons",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "tales_corra": {
    "name": "Tales Corra",
    "theme": "Tales",
    "anims": {
      "idle": {
        "rows": 1,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 6
    },
    "frameSize": 128,
    "rows": 1
  },
  "tales_wendigo": {
    "name": "Tales Wendigo",
    "theme": "Tales",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "tales_latabi": {
    "name": "Tales Latabi",
    "theme": "Tales",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "tales_nagaraja": {
    "name": "Tales Nagaraja",
    "theme": "Tales",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "grin_blue": {
    "name": "Grin Blue",
    "theme": "Plants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "grin_green": {
    "name": "Grin Green",
    "theme": "Plants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "grin_purple": {
    "name": "Grin Purple",
    "theme": "Plants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "grin_red": {
    "name": "Grin Red",
    "theme": "Plants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "grin_yellow": {
    "name": "Grin Yellow",
    "theme": "Plants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "grin_angry_blue": {
    "name": "Grin Angry Blue",
    "theme": "Plants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "grin_angry_green": {
    "name": "Grin Angry Green",
    "theme": "Plants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "grin_angry_purple": {
    "name": "Grin Angry Purple",
    "theme": "Plants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "grin_angry_red": {
    "name": "Grin Angry Red",
    "theme": "Plants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "grin_angry_yellow": {
    "name": "Grin Angry Yellow",
    "theme": "Plants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "penguin": {
    "name": "Penguin",
    "theme": "Frozen",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "frozen_penguin_mini": {
    "name": "Frozen Penguin Mini",
    "theme": "Frozen",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "snowman": {
    "name": "Snowman",
    "theme": "Frozen",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "skeleton_skull_single": {
    "name": "Skeleton Skull Single",
    "theme": "Skeletons",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "skeleton_skull_triple": {
    "name": "Skeleton Skull Triple",
    "theme": "Skeletons",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "puppet_f": {
    "name": "Puppet F",
    "theme": "Puppets",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "puppet_m": {
    "name": "Puppet M",
    "theme": "Puppets",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "seeder": {
    "name": "Seeder",
    "theme": "Plants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "treant": {
    "name": "Treant",
    "theme": "Plants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "puppet_e": {
    "name": "Puppet E",
    "theme": "Puppets",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "puppet_h": {
    "name": "Puppet H",
    "theme": "Puppets",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "puppet_s": {
    "name": "Puppet S",
    "theme": "Puppets",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "puppet_c": {
    "name": "Puppet C",
    "theme": "Puppets",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "puppet_r": {
    "name": "Puppet R",
    "theme": "Puppets",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "ghost": {
    "name": "Ghost",
    "theme": "Tales",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "ghost_christmas": {
    "name": "Ghost Christmas",
    "theme": "Tales",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "tales_aslan": {
    "name": "Tales Aslan",
    "theme": "Tales",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "tales_ishi": {
    "name": "Tales Ishi",
    "theme": "Tales",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "slime_bomber": {
    "name": "Slime Bomber",
    "theme": "Slimes",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "slime_cannon": {
    "name": "Slime Cannon",
    "theme": "Slimes",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "slime_cube": {
    "name": "Slime Cube",
    "theme": "Slimes",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "slime_flying": {
    "name": "Slime Flying",
    "theme": "Slimes",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "slime_tentacle": {
    "name": "Slime Tentacle",
    "theme": "Slimes",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "slime_large": {
    "name": "Slime Large",
    "theme": "Slimes",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "slime_tall": {
    "name": "Slime Tall",
    "theme": "Slimes",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "slime_king": {
    "name": "Slime King",
    "theme": "Slimes",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "slime_queen": {
    "name": "Slime Queen",
    "theme": "Slimes",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "plant_leaf": {
    "name": "Plant Leaf",
    "theme": "Plants",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "pet_platypus_george": {
    "name": "Pet Platypus George",
    "theme": "Pets",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "pet_platypus_george_desperado": {
    "name": "Pet Platypus George Desperado",
    "theme": "Pets",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "dragon": {
    "name": "Dragon",
    "theme": "Dragons",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "dragon_hatchling": {
    "name": "Dragon Hatchling",
    "theme": "Dragons",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "pet_octopus": {
    "name": "Pet Octopus",
    "theme": "Pets",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "pet_whale": {
    "name": "Pet Whale",
    "theme": "Pets",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "pet_raccoon": {
    "name": "Pet Raccoon",
    "theme": "Pets",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "pet_turtle": {
    "name": "Pet Turtle",
    "theme": "Pets",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "skeleton_dog": {
    "name": "Skeleton Dog",
    "theme": "Skeletons",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "skeleton_witch": {
    "name": "Skeleton Witch",
    "theme": "Skeletons",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "wolf_black": {
    "name": "Wolf Black",
    "theme": "Canines",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "wolf_brown": {
    "name": "Wolf Brown",
    "theme": "Canines",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "wolf_grey": {
    "name": "Wolf Grey",
    "theme": "Canines",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "wolf_white": {
    "name": "Wolf White",
    "theme": "Canines",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "wolf_black_raider": {
    "name": "Wolf Black Raider",
    "theme": "Canines",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "wolf_raider": {
    "name": "Wolf Raider",
    "theme": "Canines",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "deer": {
    "name": "Deer",
    "theme": "Deer",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "deer_elk": {
    "name": "Deer Elk",
    "theme": "Deer",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "deer_horned": {
    "name": "Deer Horned",
    "theme": "Deer",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "birds_crow": {
    "name": "Birds Crow",
    "theme": "Birds",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "birds_grackle": {
    "name": "Birds Grackle",
    "theme": "Birds",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "birds_eagle_bald": {
    "name": "Birds Eagle Bald",
    "theme": "Birds",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "birds_owl_great_horned": {
    "name": "Birds Owl Great Horned",
    "theme": "Birds",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "birds_arcteix": {
    "name": "Birds Arcteix",
    "theme": "Birds",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "birds_phoenix": {
    "name": "Birds Phoenix",
    "theme": "Birds",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "birds_heron": {
    "name": "Birds Heron",
    "theme": "Birds",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "birds_seagull": {
    "name": "Birds Seagull",
    "theme": "Birds",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "goblin_mage": {
    "name": "Goblin Mage",
    "theme": "Goblins",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "goblin_warrior": {
    "name": "Goblin Warrior",
    "theme": "Goblins",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "dungeon_rat": {
    "name": "Dungeon Rat",
    "theme": "Dungeon",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "dungeon_rat_large": {
    "name": "Dungeon Rat Large",
    "theme": "Dungeon",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "dungeon_bat": {
    "name": "Dungeon Bat",
    "theme": "Dungeon",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "dungeon_bat_hoary": {
    "name": "Dungeon Bat Hoary",
    "theme": "Dungeon",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "dungeon_zork_fly": {
    "name": "Dungeon Zork Fly",
    "theme": "Dungeon",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "dungeon_zork_land": {
    "name": "Dungeon Zork Land",
    "theme": "Dungeon",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "bee": {
    "name": "Bee",
    "theme": "Insects",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "bee_mini": {
    "name": "Bee Mini",
    "theme": "Insects",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      }
    },
    "frames": {
      "idle": 4
    },
    "frameSize": 128,
    "rows": 4
  },
  "bee_royal": {
    "name": "Bee Royal",
    "theme": "Insects",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "insect_beetle": {
    "name": "Insect Beetle",
    "theme": "Insects",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      }
    },
    "frames": {
      "idle": 4
    },
    "frameSize": 128,
    "rows": 4
  },
  "insect_dragonfly": {
    "name": "Insect Dragonfly",
    "theme": "Insects",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      }
    },
    "frames": {
      "idle": 4
    },
    "frameSize": 128,
    "rows": 4
  },
  "insect_firefly": {
    "name": "Insect Firefly",
    "theme": "Insects",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      }
    },
    "frames": {
      "idle": 4
    },
    "frameSize": 128,
    "rows": 4
  },
  "insect_fly": {
    "name": "Insect Fly",
    "theme": "Insects",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      }
    },
    "frames": {
      "idle": 4
    },
    "frameSize": 128,
    "rows": 4
  },
  "aquatic_orca": {
    "name": "Aquatic Orca",
    "theme": "Aquatic",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "aquatic_otter": {
    "name": "Aquatic Otter",
    "theme": "Aquatic",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      }
    },
    "frames": {
      "idle": 4
    },
    "frameSize": 128,
    "rows": 4
  },
  "aquatic_shark_thresher": {
    "name": "Aquatic Shark Thresher",
    "theme": "Aquatic",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "dungeon_mutant_pig": {
    "name": "Dungeon Mutant Pig",
    "theme": "Dungeon",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "dungeon_mutant_pig_pants": {
    "name": "Dungeon Mutant Pig Pants",
    "theme": "Dungeon",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "dungeon_mutant_piggy": {
    "name": "Dungeon Mutant Piggy",
    "theme": "Dungeon",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "farm_horse_adult": {
    "name": "Farm Horse Adult",
    "theme": "Farm",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "farm_horse_foal": {
    "name": "Farm Horse Foal",
    "theme": "Farm",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "tales_knight_cursed": {
    "name": "Tales Knight Cursed",
    "theme": "Tales",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "tales_pumpkin": {
    "name": "Tales Pumpkin",
    "theme": "Tales",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "tales_knight_night": {
    "name": "Tales Knight Night",
    "theme": "Tales",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "tales_knight_william": {
    "name": "Tales Knight William",
    "theme": "Tales",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "fire": {
    "name": "Fire",
    "theme": "Objects",
    "anims": {
      "idle": {
        "rows": 1,
        "frameSize": 64,
        "frames": 6
      }
    },
    "frames": {
      "idle": 6
    },
    "frameSize": 64,
    "rows": 1
  },
  "pillars": {
    "name": "Pillars",
    "theme": "Objects",
    "anims": {
      "idle": {
        "rows": 1,
        "frameSize": 64,
        "frames": 6
      }
    },
    "frames": {
      "idle": 6
    },
    "frameSize": 64,
    "rows": 1
  },
  "tales_horse_balius": {
    "name": "Tales Horse Balius",
    "theme": "Tales",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "tales_horse_banshee": {
    "name": "Tales Horse Banshee",
    "theme": "Tales",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "dog": {
    "name": "Dog",
    "theme": "Canines",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  },
  "canines_wolf_black": {
    "name": "Wolf Black",
    "theme": "Canines",
    "anims": {
      "idle": {
        "rows": 4,
        "frameSize": 128,
        "frames": 4
      },
      "move": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      },
      "attack": {
        "rows": 4,
        "frameSize": 128,
        "frames": 6
      }
    },
    "frames": {
      "idle": 4,
      "move": 6,
      "attack": 6
    },
    "frameSize": 128,
    "rows": 4
  }
};

export const THEMES = {
  "Ants": [
    "ant",
    "ant_mini"
  ],
  "Aquatic": [
    "aquatic_orca",
    "aquatic_otter",
    "aquatic_shark_thresher"
  ],
  "Bears": [
    "bear",
    "bear_cub",
    "bear_mutant"
  ],
  "Birds": [
    "birds_arcteix",
    "birds_crow",
    "birds_eagle_bald",
    "birds_grackle",
    "birds_heron",
    "birds_owl_great_horned",
    "birds_phoenix",
    "birds_seagull"
  ],
  "Bovine": [
    "boar",
    "pig",
    "piggy"
  ],
  "Canines": [
    "armored",
    "beagle",
    "canines_wolf_black",
    "dog",
    "labrador",
    "wolf_black",
    "wolf_black_raider",
    "wolf_brown",
    "wolf_grey",
    "wolf_raider",
    "wolf_white"
  ],
  "Deer": [
    "deer",
    "deer_elk",
    "deer_horned"
  ],
  "Dragons": [
    "dragon",
    "dragon_hatchling"
  ],
  "Dungeon": [
    "dungeon_bat",
    "dungeon_bat_hoary",
    "dungeon_mutant_pig",
    "dungeon_mutant_pig_pants",
    "dungeon_mutant_piggy",
    "dungeon_rat",
    "dungeon_rat_large",
    "dungeon_zork_fly",
    "dungeon_zork_land"
  ],
  "Elementals": [
    "elemental_air_1",
    "elemental_air_2",
    "elemental_air_3",
    "elemental_earth_1",
    "elemental_earth_2",
    "elemental_earth_3",
    "elemental_fire_1",
    "elemental_fire_2",
    "elemental_fire_3",
    "elemental_water_1",
    "elemental_water_2",
    "elemental_water_3"
  ],
  "Farm": [
    "farm_horse_adult",
    "farm_horse_foal"
  ],
  "Felines": [
    "feline_bobcat",
    "feline_mutated_panther"
  ],
  "Frozen": [
    "frozen_icer",
    "frozen_penguin_mini",
    "frozen_scorpion",
    "frozen_widow",
    "penguin",
    "snowman"
  ],
  "Goblins": [
    "goblin_dual",
    "goblin_mage",
    "goblin_spear",
    "goblin_warrior"
  ],
  "Golems": [
    "golem_blue",
    "golem_green",
    "golem_red",
    "golem_yellow"
  ],
  "Harpy": [
    "harpy",
    "harpy_undead"
  ],
  "Insects": [
    "bee",
    "bee_mini",
    "bee_royal",
    "insect_beetle",
    "insect_dragonfly",
    "insect_firefly",
    "insect_fly"
  ],
  "Knights": [
    "archer",
    "bodyguard",
    "general",
    "guardsman",
    "highborn",
    "knight",
    "knight_dark",
    "marksman",
    "royalguard",
    "spearman",
    "squire",
    "templar"
  ],
  "Machines": [
    "mmg_1",
    "mr_63"
  ],
  "Mages": [
    "monk",
    "necromancer",
    "necromancer_down",
    "necromancer_side",
    "necromancer_up",
    "priest",
    "wizard"
  ],
  "Mushrooms": [
    "mushroom",
    "mushroom_infectous",
    "mushroom_party",
    "mushroom_treant"
  ],
  "Objects": [
    "fire",
    "pillars"
  ],
  "Peasants": [
    "peasant_female_a",
    "peasant_female_b",
    "peasant_female_c",
    "peasant_male_a",
    "peasant_male_b",
    "peasant_male_c"
  ],
  "Pets": [
    "pet_octopus",
    "pet_platypus_george",
    "pet_platypus_george_desperado",
    "pet_raccoon",
    "pet_turtle",
    "pet_whale"
  ],
  "Pirates": [
    "pirate_boatswain",
    "pirate_carpenter",
    "pirate_lord",
    "pirate_mate",
    "pirate_seaman_blue",
    "pirate_seaman_red"
  ],
  "Plants": [
    "dionaea",
    "grin_angry_blue",
    "grin_angry_green",
    "grin_angry_purple",
    "grin_angry_red",
    "grin_angry_yellow",
    "grin_blue",
    "grin_green",
    "grin_purple",
    "grin_red",
    "grin_yellow",
    "plant_leaf",
    "seeder",
    "treant",
    "venus"
  ],
  "Puppets": [
    "puppet_c",
    "puppet_e",
    "puppet_f",
    "puppet_h",
    "puppet_m",
    "puppet_r",
    "puppet_s"
  ],
  "Skeletons": [
    "skeleton",
    "skeleton_archer",
    "skeleton_caster",
    "skeleton_dog",
    "skeleton_mage",
    "skeleton_marksman",
    "skeleton_skull_single",
    "skeleton_skull_triple",
    "skeleton_thug",
    "skeleton_warlord",
    "skeleton_witch",
    "witch_doctor"
  ],
  "Slimes": [
    "slime",
    "slime_antenna",
    "slime_bomber",
    "slime_cannon",
    "slime_cube",
    "slime_flying",
    "slime_king",
    "slime_large",
    "slime_queen",
    "slime_tall",
    "slime_tentacle"
  ],
  "Snakes": [
    "snake_alien",
    "snake_viper"
  ],
  "Spiders": [
    "spider",
    "spider_albino",
    "spider_large"
  ],
  "Tales": [
    "ghost",
    "ghost_christmas",
    "tales_aslan",
    "tales_corra",
    "tales_horse_balius",
    "tales_horse_banshee",
    "tales_ishi",
    "tales_knight_cursed",
    "tales_knight_night",
    "tales_knight_william",
    "tales_latabi",
    "tales_nagaraja",
    "tales_pumpkin",
    "tales_wendigo"
  ],
  "Trolls": [
    "troll",
    "troll_battle"
  ]
};
